import { FooterSectionType, SectionType } from '@/calendesk/models/BuilderTypes'
import SectionConfiguration from '@/calendesk/models/SectionConfiguration'
import StoreController from '@/calendesk/controllers/StoreController'

export default (): SectionConfiguration => {
  return {
    type: SectionType.FOOTER,
    configuration: {
      component_id: FooterSectionType.FOOTER7,
      present_height: 120,
      wb_company_name__text__: StoreController.appConfiguration()?.companyName,
      wb_facebook__url__: null,
      wb_instagram__url__: null,
      wb_twitter__url__: null,
      wb_youtube__url__: null,
      wb_linkedin__url__: null,
      wb_tiktok__url__: null,
      wb_page_list__page_ids__: []
    },
    images: []
  }
}
